function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open')
    );
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone')
      document.documentElement.style.setProperty(
        '--viewport-height',
        `${window.innerHeight}px`
      );

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector('summary')
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button')
      );
      summaryElement.nextElementSibling.removeEventListener(
        'transitionend',
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              'transitionend',
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement
      .querySelector('summary')
      .setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById('shopify-section-header');
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains(
        'header-wrapper--border-bottom'
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        )
          this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      );

      this.setAttribute('loaded', true);
      this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      ).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / sliderItemsToShow[0].clientWidth
    );
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader =
      this.stickyHeader || document.querySelector('sticky-header');
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => {
      parent.scrollLeft = 0;
      parent
        .querySelector('li.product__media-item')
        .scrollIntoView({ behavior: 'smooth' });
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

// Fetch cart contents and update cart counter element
const updateCartCounter = () => {
  const cartCounter = document.querySelectorAll('.items-counter');
  let cartItemCount;
  const displayCounter = () => {
    if (cartItemCount > 0) {
      cartCounter.forEach((el) => {
        el.style.display = 'block';
        el.innerHTML = cartItemCount;
      });
    }
  };
  fetch('/cart.js')
    .then((response) => response.json())
    .then((data) => (cartItemCount = data.item_count))
    .then((data) => (cartCounter.innerHTML = cartItemCount))
    .then((data) => displayCounter())
    .then((data) => console.log(cartItemCount));
};
updateCartCounter();

/** ##########  PRICE CALCULATOR ##########
 *
 * Create products array
 * restructure single product obj
 * display dynamic price
 */
const qtyBtns = document.querySelectorAll('.cart-btn');
const displayElement = document.querySelectorAll('.calculated-price');
const qtyElement = document.querySelectorAll('.variant-qty');
const cartNotification = document.querySelector('.cart-notification');

let products = [];

const calculateTotalPrice = (variants, id) => {
  let total = 0;
  for (let element of displayElement) {
    if (id === element.getAttribute('data-show')) {
      const productCard = element.closest('.calc-card');
      const subscriptionOption = productCard.querySelector('.purchase-option[data-type="subscription"] input');
      const isSubscription = subscriptionOption && subscriptionOption.checked;
      
      // Get the selected variant
      const selectedVariant = productCard.querySelector('.single-variant.selected .variant-title');
      if (selectedVariant) {
        const qty = parseInt(productCard.querySelector('.qty-input').value) || 1;
        let price = isSubscription ? 
          parseFloat(selectedVariant.dataset.sellingPlanPrice) : 
          parseFloat(selectedVariant.dataset.variantPrice);
        total = qty * price;
      }
      
      element.innerHTML = '$' + total.toFixed(2);
      if (element.parentElement.querySelector('.product-meta__currency')) {
        element.parentElement.querySelector('.product-meta__currency').innerHTML = 'CAD';
      }
    }
  }
};

const createProductObj = (
  addToCartBtn,
  btnType,
  id,
  handle,
  variantID,
  variantTitle,
  variantPrice,
  products,
  product,
  variant
) => {
  // Set up initial product
  product.id = id;
  product.handle = handle;
  product.qty = 1;

  // Set up variant
  variant.id = variantID;
  variant.title = variantTitle;
  variant.qty = 1;
  variant.basePrice = parseFloat(variantPrice);

  // Find or create product
  let currentProduct = products.find(p => p.id === id);
  if (!currentProduct && btnType === 'increment') {
    currentProduct = product;
    currentProduct.variants = [variant];
    products.push(currentProduct);
  }

  // Update variant quantities
  if (currentProduct) {
    let currentVariant = currentProduct.variants.find(v => v.id === variantID);
    if (!currentVariant && btnType === 'increment') {
      currentProduct.variants.push(variant);
      currentVariant = variant;
    }

    if (currentVariant) {
      const qtyInput = document.querySelector(`input[prod-variant="${variantID}"]`);
      if (qtyInput) {
        const currentQty = parseInt(qtyInput.value);
        if (btnType === 'increment') {
          qtyInput.value = currentQty + 1;
        } else if (btnType === 'decrement' && currentQty > 1) {
          qtyInput.value = currentQty - 1;
        }
        currentVariant.qty = parseInt(qtyInput.value);
      }
    }

    // Calculate and update total price
    calculateTotalPrice(currentProduct.variants, id);
  }

  // Reset price after adding to cart
  const cartBtn = addToCartBtn.closest('.product-form').querySelector('.submit-btn');
  if (cartBtn) {
    cartBtn.addEventListener('click', () => {
      const qtyInputs = document.querySelectorAll(`input[prod-variant]`);
      qtyInputs.forEach(input => {
        input.value = 1;
      });
      
      if (currentProduct) {
        currentProduct.variants.forEach(variant => {
          variant.qty = 1;
        });
        calculateTotalPrice(currentProduct.variants, id);
      }
    });
  }
};

if (qtyBtns) {
  for (let btn of qtyBtns) {
    btn.addEventListener('click', (event) => {
      event.preventDefault();

      if (btn.classList.contains('na-btn')) return;

      let btnType = btn.classList.contains('btn--inc') ? 'increment' : 'decrement';
      
      if (btnType === 'decrement') {
        const currentQty = parseInt(btn.parentElement.querySelector('input').value);
        if (currentQty <= 1) return;
      }

      const dataSelector = btn.closest('.single-variant').querySelector('small');
      if (!dataSelector) return;

      const prodInfo = {
        id: dataSelector.getAttribute('data-prod-id'),
        handle: dataSelector.getAttribute('data-prod-handle'),
        variantID: dataSelector.getAttribute('data-variant-id'),
        variantTitle: dataSelector.getAttribute('data-variant-title'),
        variantPrice: dataSelector.getAttribute('data-variant-price')
      };

      let product = {
        id: null,
        handle: null,
        qty: 1,
        variants: []
      };

      let variant = {
        id: null,
        title: null,
        qty: 1,
        basePrice: null
      };

      createProductObj(
        btn,
        btnType,
        prodInfo.id,
        prodInfo.handle,
        prodInfo.variantID,
        prodInfo.variantTitle,
        prodInfo.variantPrice,
        products,
        product,
        variant
      );
    });
  }
}

// Update variant selection to handle price updates and reset quantity
const handleVariantSelection = () => {
  const variants = document.querySelectorAll('.single-variant');
  
  variants.forEach(variant => {
    variant.addEventListener('click', () => {
      const productCard = variant.closest('.calc-card');
      // Remove selected class from all variants in this product card
      productCard.querySelectorAll('.single-variant').forEach(v => {
        v.classList.remove('selected');
      });
      // Add selected class to clicked variant
      variant.classList.add('selected');
      
      // Update form's variant ID
      const variantTitle = variant.querySelector('.variant-title');
      const variantId = variantTitle.dataset.variantId;
      const form = productCard.querySelector('form');
      const hiddenInput = form.querySelector('input[name="id"]') || document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'id';
      hiddenInput.value = variantId;
      if (!form.querySelector('input[name="id"]')) {
        form.appendChild(hiddenInput);
      }

      // Reset quantity to 1
      const qtyInput = productCard.querySelector('.qty-input');
      if (qtyInput) qtyInput.value = 1;

      // Update price
      calculateTotalPrice([], variantTitle.dataset.prodId);
    });
  });
};

// Update purchase option selection to reset quantity
const handlePurchaseOptionSelection = () => {
  const purchaseOptions = document.querySelectorAll('.purchase-option');
  
  purchaseOptions.forEach(option => {
    option.addEventListener('click', (e) => {
      const container = option.closest('.purchase-options');
      container.querySelectorAll('.purchase-option').forEach(opt => {
        opt.classList.remove('selected');
      });
      option.classList.add('selected');
      option.querySelector('input[type="radio"]').checked = true;
      
      const productCard = option.closest('.calc-card');
      const isSubscription = option.dataset.type === 'subscription';

      // Reset quantity to 1
      const qtyInput = productCard.querySelector('.qty-input');
      if (qtyInput) qtyInput.value = 1;
      
      // Update prices
      const selectedVariant = productCard.querySelector('.single-variant.selected .variant-title');
      if (selectedVariant) {
        calculateTotalPrice([], selectedVariant.dataset.prodId);
      }

      // Update hidden selling plan input
      const form = productCard.querySelector('form');
      let sellingPlanInput = form.querySelector('input[name="selling_plan"]');
      if (isSubscription) {
        if (!sellingPlanInput) {
          sellingPlanInput = document.createElement('input');
          sellingPlanInput.type = 'hidden';
          sellingPlanInput.name = 'selling_plan';
          form.appendChild(sellingPlanInput);
        }
        sellingPlanInput.value = option.querySelector('input[type="radio"]').value;
      } else if (sellingPlanInput) {
        sellingPlanInput.remove();
      }
    });
  });
};

// Add to cart functionality
document.addEventListener('click', async (e) => {
  if (e.target.matches('.submit-btn')) {
    e.preventDefault();
    
    const productCard = e.target.closest('.calc-card');
    const form = productCard.querySelector('form');
    const selectedVariant = productCard.querySelector('.single-variant.selected .variant-title');
    const qty = parseInt(productCard.querySelector('.qty-input').value) || 1;

    if (!selectedVariant || !form) return;

    const variantId = selectedVariant.dataset.variantId;
    const productTitle = selectedVariant.dataset.prodTitle;
    
    // Prepare cart data as JSON instead of FormData
    let cartData = {
      items: [{
        id: variantId,
        quantity: qty
      }]
    };

    // Add selling plan if subscription is selected
    const subscriptionOption = productCard.querySelector('.purchase-option[data-type="subscription"] input:checked');
    if (subscriptionOption && subscriptionOption.value !== 'onetime') {
      cartData.items[0].selling_plan = subscriptionOption.value;
    }

    // Store original button text
    const originalBtnText = e.target.textContent;
    e.target.textContent = 'Adding...';
    e.target.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(cartData)
      });

      if (!response.ok) throw new Error('Add to cart failed');
      
      const result = await response.json();

      // Show notification
      const notification = document.querySelector('.cart-notification');
      if (notification) {
        notification.innerHTML = `${productTitle} added to cart`;
        notification.classList.remove('notification-deactive');
        notification.classList.add('notification-active');
        
        setTimeout(() => {
          notification.classList.remove('notification-active');
          notification.classList.add('notification-deactive');
        }, 2000);
      }

      // Reset quantity to 1
      const qtyInput = productCard.querySelector('.qty-input');
      if (qtyInput) qtyInput.value = 1;
      
      // Reset price display
      const priceDisplay = productCard.querySelector('.calculated-price');
      if (priceDisplay) {
        const basePrice = selectedVariant.dataset.variantPrice;
        priceDisplay.innerHTML = `$${basePrice}`;
      }

      // Update cart counter if it exists
      if (typeof updateCartCounter === 'function') {
        updateCartCounter();
      }
    } catch (error) {
      console.error('Error:', error);
      const notification = document.querySelector('.cart-notification');
      if (notification) {
        notification.innerHTML = 'Error adding to cart';
        notification.classList.remove('notification-deactive');
        notification.classList.add('notification-active');
        
        setTimeout(() => {
          notification.classList.remove('notification-active');
          notification.classList.add('notification-deactive');
        }, 2000);
      }
    } finally {
      e.target.textContent = originalBtnText;
      e.target.disabled = false;
    }
  }
});

// Update quantity buttons functionality
document.addEventListener('click', (e) => {
  if (e.target.matches('.btn--inc, .btn--dec')) {
    e.preventDefault();
    const productCard = e.target.closest('.calc-card');
    if (!productCard) return;

    const qtyInput = productCard.querySelector('.qty-input');
    if (!qtyInput) return;

    let currentQty = parseInt(qtyInput.value) || 1;
    
    if (e.target.matches('.btn--inc')) {
      currentQty += 1;
    } else if (currentQty > 1) {
      currentQty -= 1;
    }
    
    qtyInput.value = currentQty;

    // Update price calculation
    const selectedVariant = productCard.querySelector('.single-variant.selected .variant-title');
    if (selectedVariant) {
      calculateTotalPrice([], selectedVariant.dataset.prodId);
    }
  }
});

// Select first variant by default on page load
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.variant-container').forEach(container => {
    const firstVariant = container.querySelector('.single-variant');
    if (firstVariant) {
      firstVariant.classList.add('selected');
      // Trigger click to initialize the form
      firstVariant.click();
    }
  });
  
  const purchaseOptions = document.querySelectorAll('.purchase-options');
  if (purchaseOptions.length > 0) {
    handlePurchaseOptionSelection();
  }
  handleVariantSelection();
});